import { MentorGqlApiTagTypes } from 'app/apis/mentor-gql-api';
import { api as createMentorApi } from './create-mentor.generated';
import { api as getMentorApi } from './get-mentor.generated';
import { api as getMentorAgreementsApi } from './get-mentor-agreements.generated';
import { api as updateMentorApi } from './update-mentor.generated';
import { api as updateMentorAgreementApi } from './update-mentor-agreement.generated';

getMentorApi.enhanceEndpoints({
  endpoints: {
    MentorDash_MentorQuery: {
      providesTags: [MentorGqlApiTagTypes.Mentor],
    },
  },
});

getMentorAgreementsApi.enhanceEndpoints({
  endpoints: {
    MentorDash_GetMentorAgreements: {
      providesTags: [MentorGqlApiTagTypes.Agreements],
    },
  },
});

createMentorApi.enhanceEndpoints({
  endpoints: {
    MentorDash_CreateMentor: {
      invalidatesTags: [MentorGqlApiTagTypes.Mentor],
    },
  },
});

updateMentorApi.enhanceEndpoints({
  endpoints: {
    MentorDash_UpdateMentor: {
      invalidatesTags: [MentorGqlApiTagTypes.Mentor],
    },
  },
});

updateMentorAgreementApi.enhanceEndpoints({
  endpoints: {
    MentorDash_UpdateMentorAgreement: {
      invalidatesTags: [MentorGqlApiTagTypes.Agreements],
    },
  },
});

export const { useMentorDash_MentorQueryQuery: useGetMentorQuery } = getMentorApi;
export const { useMentorDash_GetMentorAgreementsQuery: useGetMentorAgreementsQuery } = getMentorAgreementsApi;
export const { useMentorDash_CreateMentorMutation: useCreateMentorMutation } = createMentorApi;
export const { useMentorDash_UpdateMentorMutation: useUpdateMentorMutation } = updateMentorApi;
export const { useMentorDash_UpdateMentorAgreementMutation: useUpdateMentorAgreementMutation } =
  updateMentorAgreementApi;

export { getMentorApi };
